import { Button, IconButton, SxProps, Typography } from "@mui/material"
import CloseIcon from "components/icons/base/close"
import { useRef } from "react"
import { ListValuesContainer, ListValuesItem } from "./styled"

type Props = {
  values: string[],
  setValues: (values: string[]) => void,
  sx?: SxProps
}

const ListValues = ({ values, setValues, sx }: Props) => {

  const ref = useRef<HTMLDivElement>(null)

  const addItem = () => {
    setValues([ ...values, "" ])
    requestAnimationFrame(() => {
      if (!ref.current) return
      const val = Array.from(ref.current.querySelectorAll('.value')).at(-1) as HTMLInputElement
      val?.querySelector('input')?.focus()
    })
  }

  const changeValue = (index: number, value: string) => {
    setValues(values.map((val, i) => i === index? value: val))
  }

  const deleteValue = (index: number) => {
    setValues(values.filter((_, i) => index !== i))
  }

  return (
    <ListValuesContainer ref={ref} sx={sx}>
      <Typography color="text.secondary" fontSize={10} mb={0.5}>
        Варианты выбора
      </Typography>
      { values.map((value, index) => (
        <ListValuesItem key={index} className="value">
          <input 
            placeholder="Введите значение"
            value={value} 
            onChange={e => changeValue(index, e.target.value)} 
          />
          <IconButton size="small" color="info" onClick={e => deleteValue(index)}>
            <CloseIcon fontSize="small" sx={{ color: "text.secondary" }}/>
          </IconButton>
        </ListValuesItem>
      ))}
      <Button variant="text" onClick={addItem} sx={{ bgcolor: "background.default", color: "primary.main" }}>
        Добавить вариант
      </Button>
    </ListValuesContainer>
  )

}

export default ListValues